import React from 'react';
import { Typography, Button } from 'antd';
import { Row, Col } from 'react-flexbox-grid';  
import { withRouter } from 'react-router';
import err from '../../assets/bg/14.svg';

const ERR_404 = (props) => {

    const { Title } = Typography;

    const handleNav = () => {
        props.history.push({
            pathname: '/'
        });
    }

    return(
        <div className="error-container" style={{ width: '100%', height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }} >
            <Row className="no-margin main-container-hero" style={{ marginTop: 80, width: '100%', height: '100%' }} >
                <Col xs={12} sm={12} md={12} lg={6} style={{ padding: '10rem 3rem 12rem 0rem', width: '100%', height: '100%', display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', flexDirection: 'column' }} >
                    <Title className="main-title-color" style={{ padding: '.25em 0em', fontSize: '3.25rem' }}>
                        Whooops!
                    </Title>
                    <span className="montserrat secondary-title-color" style={{ fontSize: '1.3rem' }} >
                        La página que buscas tal vez fue removida o esta temporalmente inaccesible.
                    </span>
                    <div style={{ marginTop: '1.55em', width: '100%', display: 'flex', alignItems: 'center', flexDirection: 'row' }} >
                        <Button type="primary" shape="round" size="large" className="main-cta" onClick={() => handleNav()} style={{ height: 50 }} >
                            <span className="no-margin montserrat" style={{ fontSize: '1.15rem' }}>
                                Regresar a algo existente
                            </span>  
                        </Button>
                    </div>
                </Col>
                <Col className="no-padding" xs={12} sm={12} md={12} lg={6}>
                    <img src={err} alt={err} style={{ width: '100%', height: '100%', marginLeft: '-2em' }} />
                </Col>
            </Row>
        </div>
    )
}

export default withRouter(ERR_404);